import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../../../style/AdminRejectedOrder.css";
import { apiAxios } from "../../../../utils/apiAxios";

const API_BASE = process.env.REACT_APP_API_BASE_URL;
const RejectionReasonCell = ({ reason }: { reason: string }) => {
  const [expanded, setExpanded] = React.useState(false);

  const limit = 50;
  const text = reason || "";
  const isLong = text.length > limit;

  return (
    <div style={{ maxWidth: "200px" }}>
      <span
        style={{
          // whiteSpace: expanded ? "normal" : "nowrap",
          overflow: "hidden",
          textOverflow: expanded ? "unset" : "ellipsis",
          display: "block",
        }}
      >
        {expanded ? text : text.slice(0, limit) + (isLong ? "..." : "")}
      </span>

      {isLong && (
          <span
  className="view-more-section"
  onClick={() => setExpanded(!expanded)}
>
  {expanded ? "View Less" : "View More"}
</span>
      )}
    </div>
  );
};
const AdminRejectedOrder = () => {
  const [orders, setOrders] = useState<any[]>([]);
  const [millingOrders, setMillingOrders] = useState<any[]>([]);

  const [loading, setLoading] = useState(false);
  const [millingLoading, setMillingLoading] = useState(false);

  const [rejectionLogs, setRejectionLogs] = useState<any[]>([]);
  const [logsLoading, setLogsLoading] = useState(false);

  const [showModal, setShowModal] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState<any>(null);
  const [open, setOpen] = useState(true);
  const [activeTab, setActiveTab] = useState("designer");

  const [openIndex, setOpenIndex] = useState<number | null>(null);

  // 🔥 Tab based API call
  useEffect(() => {
    if (activeTab === "designer") {
      fetchRejectedOrders();
    } else if (activeTab === "milling") {
      fetchMillingRejectedOrders();
    }
  }, [activeTab]);

  const toggleAccordion = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
const formatDateTime = (date: string | Date) => {
  if (!date) return "";

  return new Date(date)
    .toLocaleString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true, // Set false for 24-hour format
    })
    .replace(",", "");
};
  // ✅ Designer API
  const fetchRejectedOrders = async () => {
    try {
      setLoading(true);

      const response = await apiAxios.get(`${API_BASE}/Central/rejected-cases`);

      const result = response.data; // ✅ FIXED

      if (result) {
        const apiData = Array.isArray(result.data?.dataOne)
          ? result.data.dataOne
          : Array.isArray(result.data)
            ? result.data
            : [];

        const formattedData = apiData.map((item: any) => ({
          caseId: item.caseID,
          orderId: item.orderID,
          designerName: item.designerName,
          rejectionReason: item.reason,
          nextDesigner: item.assignedDesigner,
          status: "Rejected",
        }));

        setOrders(formattedData);
      }
    } catch (error) {
      console.error("Error fetching designer rejected orders", error);
    } finally {
      setLoading(false);
    }
  };

  // ✅ Milling API
  const fetchMillingRejectedOrders = async () => {
    try {
      setMillingLoading(true);

      const response = await apiAxios.get(`${API_BASE}/Central/rejected-cases-ForMilling`);



      const result = response.data;

      if (result) {
        const apiData = result.data.dataOne || result.data;

        const formattedData = apiData.map((item: any) => ({
          caseId: item.caseID,
          orderId: item.orderID,
          designerName: item.millingName || item.designerName,
          rejectionReason: item.reason,
          nextDesigner: item.assignedMillingHub || item.assignedDesigner,
          status: "Rejected",
        }));

        setMillingOrders(formattedData);
      }
    } catch (error) {
      console.error("Error fetching milling rejected orders", error);
    } finally {
      setMillingLoading(false);
    }
  };


  const fetchRejectionLogs = async (caseId: number) => {
    try {
      setLogsLoading(true);

      const url =
        activeTab === "designer"
          ? `/Central/rejection-logs/${caseId}`
          : `/Central/rejection-logs-milling/${caseId}`;

      const response = await apiAxios.get(`${API_BASE}${url}`);

      const result = response;

    if (result?.data?.success) {
      console.log(result,"*********")
  return result.data.data || [];

}

      return [];
    } catch (error) {
      console.error("Error fetching rejection logs", error);
      return [];
    } finally {
      setLogsLoading(false);
    }
  };

  // 📊 Table Columns
  const columns = [
    {
      name: "Order ID",
      selector: (row: any) => row.orderId,
      sortable: true,
    },
    {
      name: "User Name",
        minWidth: "180px",
      selector: (row: any) => row.designerName,
      sortable: true,
      wrap: true, 
    },
{
  name: "Rejection Reason",
   minWidth: "180px",
  selector: (row: any) => row.rejectionReason,
  sortable: true,
  cell: (row: any) => (
    <RejectionReasonCell reason={row.rejectionReason || ""} />
  ),
},
    {
      name: "Status",
      width:"260px",
      cell: (row: any) => (
        <button
          className="btn btn-danger btn-reject-section btn-sm"
          onClick={async () => {
            setSelectedOrder(row);
            const logs = await fetchRejectionLogs(row.caseId);
            if (logs.length > 0) {
              setRejectionLogs(logs);
              setOpenIndex(null);
              setShowModal(true);
            } else {
              alert("No rejection logs found");
            }
          }}
        >
          {row.nextDesigner}
        </button>
      ),
    },
  ];

  return (
    <div className="mt-2">
      <h4 className="mb-4">Rejected Orders</h4>

      {/* Tabs */}
      <div className="d-flex justify-content-center mb-5 mt-4 gap-3">
        <div
          className={`tab-btn ${activeTab === "designer" ? "active" : ""}`}
          onClick={() => setActiveTab("designer")}
        >
          Designer Rejected Orders
        </div>

        <div
          className={`tab-btn ${activeTab === "milling" ? "active" : ""}`}
          onClick={() => setActiveTab("milling")}
        >
          Milling Rejected Orders
        </div>
      </div>

      {/* Table */}
      <div className="premium-card">
        {activeTab === "designer" && (
          <DataTable
            columns={columns}
            data={orders}
             className="rejectmy-data-table"
            progressPending={loading}
            pagination
            highlightOnHover
            striped
            responsive
          />
        )}

        {activeTab === "milling" && (
          <DataTable
              className="rejectmy-data-table"
            columns={columns}
            data={millingOrders}
            progressPending={millingLoading}
            pagination
            highlightOnHover
            striped
            responsive
          />
        )}
      </div>

      {/* Modal */}
      {showModal && selectedOrder && (
        <div
          className="modal fade show"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog">
            <div className="modal-content">

              <div className="modal-header">
                <h5 className="modal-title">
                  Order {selectedOrder.orderId} - Previously Assigned to {selectedOrder.designerName}
                </h5>
                <button
                  className="btn-close custom-close-btn"
                  onClick={() => setShowModal(false)}
                >
                  <i className="bi bi-x customcross"></i>
                </button>
              </div>

              <div className="modal-body">
                <h6 className="mb-3">Rejection Logs :</h6>

                {logsLoading ? (
                  <p>Loading logs...</p>
                ) : rejectionLogs.length === 0 ? (
                  <p>No logs found</p>
                ) : (
                  rejectionLogs.map((log, index) => {
                    const isOpen = openIndex === index;

                    return (
                      <div key={index} className={`accordion-card ${isOpen ? "active" : ""}`}>

                        {/* Header */}
                        <div
                          className="accordion-header-rejected-order"
                          onClick={() => toggleAccordion(index)}
                          style={{ cursor: "pointer" }}
                        >
                          <div className="header-left">
                            <span>Order Rejected by {log.designerName || log.millingName}</span>
                          </div>

                          <i
                            className={`bi ${isOpen ? "bi-chevron-up" : "bi-chevron-down"
                              } toggle-icon toggle-icon-accordion`}
                          ></i>
                        </div>

                        {/* Body */}
                        <div className={`accordion-body-rejected ${isOpen ? "show" : ""}`}>
                          <div className="log-row">
                            <span>Rejected on : </span>
                            <strong>
                             <strong>{formatDateTime(log.rejectedOn)}</strong>
                            </strong>
                          </div>

                          <div className="log-row">
                            <span>Reason : </span>
                            <div className="reason-in-text">{log.reason}</div>
                          </div>

                          <div className="log-row">
                            <span>Reassigned to : </span>
                            <strong>{log.assignedDesigner || log.assignedMillingHub || "N/A"}</strong>
                          </div>
                        </div>

                      </div>
                    );
                  })
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminRejectedOrder;